document.addEventListener('DOMContentLoaded', function() {
  document.getElementById('revealBtn').addEventListener('click', function() {
            // Hide the button
            this.classList.add('hidden');
            
            // Show the accordion content
            document.getElementById('accordionContent').classList.add('show');
        });
  // Track Color/Colore changes (group swatches)
  const colorSwatches = document.querySelectorAll('.swatch-group-selector');
  
  colorSwatches.forEach(swatch => {
    swatch.addEventListener('click', function() {
      const colorValue = this.getAttribute('data-value');
      const colorOrigValue = this.getAttribute('orig-value');
      
      console.log('Color changed to:', colorValue);
      
      // Update hidden field and display
      updateFormFields('color', colorValue);
      updateDisplay('color', colorValue);
      setTimeout(checkSkuUpdate, 100);
    });
  });
  
  // Track Size/Taglia changes (button swatches)
  const sizeSwatches = document.querySelectorAll('.swatch-selector[swatch-option="option1"]');
  
  sizeSwatches.forEach(swatch => {
    swatch.addEventListener('click', function() {
      const sizeValue = this.getAttribute('data-value');
      const optionValueId = this.getAttribute('option-value-id');
      
      console.log('Size changed to:', sizeValue);
      console.log('Option Value ID:', optionValueId);
      
      // Update hidden fields and display
      updateFormFields('size', sizeValue, optionValueId);
      updateDisplay('size', sizeValue);
      updateDisplay('variant-id', optionValueId);
      setTimeout(checkSkuUpdate, 100);
    });
  });
  
  // Function to update hidden form fields
  function updateFormFields(type, value, optionId = null) {
    if (type === 'color') {
      const colorField = document.getElementById('hidden-color');
      if (colorField) {
        colorField.value = value;
      }
    } else if (type === 'size') {
      const sizeField = document.getElementById('hidden-size');
      if (sizeField) {
        sizeField.value = value;
      }
      
      if (optionId) {
        const variantField = document.getElementById('hidden-variant-id');
        if (variantField) {
          variantField.value = optionId;
        }
      }
    }
  }

  
  
  // Function to check and update SKU
  function checkSkuUpdate() {
    const skuElement = document.getElementById('optionSKU');
  let lastSku = '';
    if (!skuElement) return;
    
    const currentSku = skuElement.textContent.trim() || skuElement.getAttribute('data-option-sku');
    
    // Only update if SKU has changed
    if (currentSku !== lastSku) {
      console.log('SKU updated:', currentSku);
      lastSku = currentSku;
      
      // Update form fields
      if (document.getElementById('hidden-variant-sku')) {
        document.getElementById('hidden-variant-sku').value = currentSku;
      }
      if (document.getElementById('display-variant-sku')) {
        document.getElementById('display-variant-sku').textContent = currentSku || 'N/A';
      }
    }
  }
  // Function to update visible display labels
  function updateDisplay(type, value) {
    const displayElement = document.getElementById('display-' + type);
    if (displayElement) {
      displayElement.textContent = value || '-';
      // Add highlight animation
      displayElement.style.backgroundColor = '#ffeb3b';
      setTimeout(() => {
        displayElement.style.backgroundColor = 'transparent';
      }, 500);
    }
  }
  
  // Get currently selected values on page load
  function getCurrentSelections() {
    const selectedColor = document.querySelector('.swatch-group-selector.swatch-selected');
    const selectedSize = document.querySelector('.swatch-selector.swatch-selected[swatch-option="option1"]');
    
    return {
      color: selectedColor ? selectedColor.getAttribute('data-value') : null,
      size: selectedSize ? selectedSize.getAttribute('data-value') : null,
      sizeId: selectedSize ? selectedSize.getAttribute('option-value-id') : null
    };
  }
  
  // Initialize form with current selections
  const currentSelections = getCurrentSelections();
  checkSkuUpdate();
  console.log('Current selections:', currentSelections);
  
  if (currentSelections.color) {
    updateFormFields('color', currentSelections.color);
    updateDisplay('color', currentSelections.color);
  }
  
  if (currentSelections.size) {
    updateFormFields('size', currentSelections.size, currentSelections.sizeId);
    updateDisplay('size', currentSelections.size);
    updateDisplay('variant-id', currentSelections.sizeId);
  }
});